import themeConfig from '@themeConfig';

 export default ({
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false
  },
  getters: {
    currentBreakPoint: state => {
      const {
        windowWidth
      } = state;
      if (windowWidth >= themeConfig["$themeBreakpoints"].xl) return 'xl';
      if (windowWidth >= themeConfig["$themeBreakpoints"].lg) return 'lg';
      if (windowWidth >= themeConfig["$themeBreakpoints"].md) return 'md';
      if (windowWidth >= themeConfig["$themeBreakpoints"].sm) return 'sm';
      return 'xs';
    }
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val;
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay;
    }
  },
  actions: {}
});

